import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "wide1": "root-b33b72b3-wide1-WXUgJq",
  "tinyOffset5": "root-b33b72b3-tinyOffset5-WXUgJq",
  "xwideOffset11": "root-b33b72b3-xwideOffset11-WXUgJq",
  "tiny10": "root-b33b72b3-tiny10-WXUgJq",
  "defaultOffset11": "root-b33b72b3-defaultOffset11-WXUgJq",
  "xwide12": "root-b33b72b3-xwide12-WXUgJq",
  "wide4": "root-b33b72b3-wide4-WXUgJq",
  "wideOffset2": "root-b33b72b3-wideOffset2-WXUgJq",
  "defaultOffset10": "root-b33b72b3-defaultOffset10-WXUgJq",
  "wideOffset8": "root-b33b72b3-wideOffset8-WXUgJq",
  "wide8": "root-b33b72b3-wide8-WXUgJq",
  "tinyOffset4": "root-b33b72b3-tinyOffset4-WXUgJq",
  "xwide3": "root-b33b72b3-xwide3-WXUgJq",
  "xwideOffset2": "root-b33b72b3-xwideOffset2-WXUgJq",
  "wideOffset4": "root-b33b72b3-wideOffset4-WXUgJq",
  "default1": "root-b33b72b3-default1-WXUgJq",
  "wideOffset1": "root-b33b72b3-wideOffset1-WXUgJq",
  "confined4": "root-b33b72b3-confined4-WXUgJq",
  "xwide11": "root-b33b72b3-xwide11-WXUgJq",
  "confinedOffset10": "root-b33b72b3-confinedOffset10-WXUgJq",
  "wide7": "root-b33b72b3-wide7-WXUgJq",
  "confined2": "root-b33b72b3-confined2-WXUgJq",
  "default7": "root-b33b72b3-default7-WXUgJq",
  "default12": "root-b33b72b3-default12-WXUgJq",
  "xwide10": "root-b33b72b3-xwide10-WXUgJq",
  "xwide8": "root-b33b72b3-xwide8-WXUgJq",
  "confinedOffset0": "root-b33b72b3-confinedOffset0-WXUgJq",
  "xwideOffset5": "root-b33b72b3-xwideOffset5-WXUgJq",
  "confinedOffset7": "root-b33b72b3-confinedOffset7-WXUgJq",
  "tiny9": "root-b33b72b3-tiny9-WXUgJq",
  "confinedOffset8": "root-b33b72b3-confinedOffset8-WXUgJq",
  "default0": "root-b33b72b3-default0-WXUgJq",
  "confined11": "root-b33b72b3-confined11-WXUgJq",
  "confinedOffset9": "root-b33b72b3-confinedOffset9-WXUgJq",
  "wide9": "root-b33b72b3-wide9-WXUgJq",
  "wideOffset0": "root-b33b72b3-wideOffset0-WXUgJq",
  "tinyOffset8": "root-b33b72b3-tinyOffset8-WXUgJq",
  "wideOffset9": "root-b33b72b3-wideOffset9-WXUgJq",
  "xwide1": "root-b33b72b3-xwide1-WXUgJq",
  "confined12": "root-b33b72b3-confined12-WXUgJq",
  "default3": "root-b33b72b3-default3-WXUgJq",
  "standardGridContainer": "root-b33b72b3-standardGridContainer-WXUgJq",
  "tiny4": "root-b33b72b3-tiny4-WXUgJq",
  "wideOffset6": "root-b33b72b3-wideOffset6-WXUgJq",
  "wideOffset11": "root-b33b72b3-wideOffset11-WXUgJq",
  "tiny3": "root-b33b72b3-tiny3-WXUgJq",
  "tiny0": "root-b33b72b3-tiny0-WXUgJq",
  "wideOffset7": "root-b33b72b3-wideOffset7-WXUgJq",
  "col": "root-b33b72b3-col-WXUgJq",
  "tiny12": "root-b33b72b3-tiny12-WXUgJq",
  "wide12": "root-b33b72b3-wide12-WXUgJq",
  "xwideOffset3": "root-b33b72b3-xwideOffset3-WXUgJq",
  "confinedOffset11": "root-b33b72b3-confinedOffset11-WXUgJq",
  "xwide5": "root-b33b72b3-xwide5-WXUgJq",
  "xwideOffset6": "root-b33b72b3-xwideOffset6-WXUgJq",
  "confinedOffset4": "root-b33b72b3-confinedOffset4-WXUgJq",
  "defaultOffset2": "root-b33b72b3-defaultOffset2-WXUgJq",
  "tiny11": "root-b33b72b3-tiny11-WXUgJq",
  "defaultOffset1": "root-b33b72b3-defaultOffset1-WXUgJq",
  "wide5": "root-b33b72b3-wide5-WXUgJq",
  "wideGridContainer": "root-b33b72b3-wideGridContainer-WXUgJq",
  "confined5": "root-b33b72b3-confined5-WXUgJq",
  "armstrongGridContainer": "root-b33b72b3-armstrongGridContainer-WXUgJq",
  "wide6": "root-b33b72b3-wide6-WXUgJq",
  "xwideOffset9": "root-b33b72b3-xwideOffset9-WXUgJq",
  "wideOffset3": "root-b33b72b3-wideOffset3-WXUgJq",
  "wide10": "root-b33b72b3-wide10-WXUgJq",
  "tiny7": "root-b33b72b3-tiny7-WXUgJq",
  "xwide2": "root-b33b72b3-xwide2-WXUgJq",
  "wide3": "root-b33b72b3-wide3-WXUgJq",
  "tiny8": "root-b33b72b3-tiny8-WXUgJq",
  "confined3": "root-b33b72b3-confined3-WXUgJq",
  "xwideOffset8": "root-b33b72b3-xwideOffset8-WXUgJq",
  "default8": "root-b33b72b3-default8-WXUgJq",
  "defaultOffset7": "root-b33b72b3-defaultOffset7-WXUgJq",
  "xwide7": "root-b33b72b3-xwide7-WXUgJq",
  "default11": "root-b33b72b3-default11-WXUgJq",
  "xwide9": "root-b33b72b3-xwide9-WXUgJq",
  "defaultOffset3": "root-b33b72b3-defaultOffset3-WXUgJq",
  "confinedOffset5": "root-b33b72b3-confinedOffset5-WXUgJq",
  "xwideOffset0": "root-b33b72b3-xwideOffset0-WXUgJq",
  "tinyOffset2": "root-b33b72b3-tinyOffset2-WXUgJq",
  "wide11": "root-b33b72b3-wide11-WXUgJq",
  "default9": "root-b33b72b3-default9-WXUgJq",
  "row": "root-b33b72b3-row-WXUgJq",
  "xwide0": "root-b33b72b3-xwide0-WXUgJq",
  "default2": "root-b33b72b3-default2-WXUgJq",
  "tinyOffset10": "root-b33b72b3-tinyOffset10-WXUgJq",
  "wideOffset5": "root-b33b72b3-wideOffset5-WXUgJq",
  "tiny6": "root-b33b72b3-tiny6-WXUgJq",
  "tiny2": "root-b33b72b3-tiny2-WXUgJq",
  "wideOffset10": "root-b33b72b3-wideOffset10-WXUgJq",
  "defaultOffset9": "root-b33b72b3-defaultOffset9-WXUgJq",
  "defaultOffset5": "root-b33b72b3-defaultOffset5-WXUgJq",
  "gridContainer": "root-b33b72b3-gridContainer-WXUgJq",
  "tinyOffset6": "root-b33b72b3-tinyOffset6-WXUgJq",
  "confinedOffset2": "root-b33b72b3-confinedOffset2-WXUgJq",
  "confined7": "root-b33b72b3-confined7-WXUgJq",
  "tinyOffset0": "root-b33b72b3-tinyOffset0-WXUgJq",
  "tinyOffset3": "root-b33b72b3-tinyOffset3-WXUgJq",
  "tinyOffset9": "root-b33b72b3-tinyOffset9-WXUgJq",
  "confinedOffset1": "root-b33b72b3-confinedOffset1-WXUgJq",
  "defaultOffset6": "root-b33b72b3-defaultOffset6-WXUgJq",
  "default4": "root-b33b72b3-default4-WXUgJq",
  "confinedOffset6": "root-b33b72b3-confinedOffset6-WXUgJq",
  "xwideOffset4": "root-b33b72b3-xwideOffset4-WXUgJq",
  "tiny1": "root-b33b72b3-tiny1-WXUgJq",
  "xwideOffset1": "root-b33b72b3-xwideOffset1-WXUgJq",
  "confined6": "root-b33b72b3-confined6-WXUgJq",
  "xwideOffset7": "root-b33b72b3-xwideOffset7-WXUgJq",
  "wide2": "root-b33b72b3-wide2-WXUgJq",
  "xwide6": "root-b33b72b3-xwide6-WXUgJq",
  "grid": "root-b33b72b3-grid-WXUgJq",
  "default10": "root-b33b72b3-default10-WXUgJq",
  "tiny5": "root-b33b72b3-tiny5-WXUgJq",
  "confined8": "root-b33b72b3-confined8-WXUgJq",
  "default6": "root-b33b72b3-default6-WXUgJq",
  "confinedOffset3": "root-b33b72b3-confinedOffset3-WXUgJq",
  "defaultOffset4": "root-b33b72b3-defaultOffset4-WXUgJq",
  "tinyOffset1": "root-b33b72b3-tinyOffset1-WXUgJq",
  "wide0": "root-b33b72b3-wide0-WXUgJq",
  "xwide4": "root-b33b72b3-xwide4-WXUgJq",
  "confined0": "root-b33b72b3-confined0-WXUgJq",
  "default5": "root-b33b72b3-default5-WXUgJq",
  "tinyOffset11": "root-b33b72b3-tinyOffset11-WXUgJq",
  "xwideOffset10": "root-b33b72b3-xwideOffset10-WXUgJq",
  "confined1": "root-b33b72b3-confined1-WXUgJq",
  "tinyOffset7": "root-b33b72b3-tinyOffset7-WXUgJq",
  "defaultOffset8": "root-b33b72b3-defaultOffset8-WXUgJq",
  "confined9": "root-b33b72b3-confined9-WXUgJq",
  "confined10": "root-b33b72b3-confined10-WXUgJq"
};